import { Gift } from "lucide-react";
import datetimeProvider from "../../../../../providers/datetime.provider";
import { packages } from "../../../../constant/marketing/product.constant";

export const christmas2025Prizes = [
    {
        key: "desconto10",
        label: "10% OFF",
        subLabel: "Em qualquer pacote",
        package: [packages.start.id, packages.premium.id],
    },
    {
        key: 'calculoSimples',
        label: "Cálculo Simples",
        package: [packages.start.id],
    },
    {
        key: "peticaoGratis",
        label: "1 Petição Grátis",
        package: [packages.start.id, packages.premium.id],
    },
    {
        key: "guiaGratis",
        label: "1 Emissão de Guias Grátis",
        package: [packages.start.id],
    },
    {
        key: "audienciaVirtualGratis",
        label: "1 Audiência Virtual Grátis",
        package: [packages.start.id],
    },
    {
        key: "calculos350",
        label: "Cálculos R$350",
        package: [packages.premium.id, packages.infinity.id],
    },
    {
        key: "audienciaPresencialGratis",
        label: "1 Audiência Presencial Grátis",
        package: [packages.premium.id],
    },
    {
        key: "peticaoExpress",
        label: "Petição Express",
        package: [packages.premium.id],
    },
    {
        key: "peticaoGratis2",
        label: "2 Petições Grátis",
        package: [packages.infinity.id],
    },
    {
        key: "peticaoExpress2",
        label: "2 Petições Express",
        package: [packages.infinity.id],
    },
    {
        key: "audienciaPresencialGratis2",
        label: "2 Audiências Presenciais Grátis",
        package: [packages.infinity.id],
    },
    {
        key: "desconto15",
        label: "15% OFF",
        subLabel: "Em qualquer pacote",
        package: [packages.infinity.id],
    },
];

const eventChristmas2025Config = {
    key: 'christmas2025',
    initialDate: '2025-12-01',
    finalDate: '2025-12-25',
    hasPrizeSelection: true,
    validator: function () {
        return datetimeProvider.getDate().isBetween(this.initialDate, this.finalDate, 'day', '[]');
    },
    packages: {
        [packages.start.id]: {
            name: 'Start Natal',
            icon: () => <span className="text-2xl">🎄</span>,
            primaryColor: '#059669',
            secondaryColor: '#059669',
        },
        [packages.premium.id]: {
            name: 'Premium Natal',
            icon: () => <span className="text-2xl">⭐</span>,
        },
        [packages.infinity.id]: {
            name: 'Infinity Natal',
        }
    },
    header: () => (
        <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
                {/* Badge */}
                <div className="inline-flex items-center gap-2 bg-blue-800 text-white px-4 py-2 rounded-full text-sm font-medium mb-8">
                    <Gift className="w-4 h-4 text-amber-400" />
                    PRESENTE ESPECIAL NA COMPRA DE QUALQUER PACOTE
                </div>

                {/* Headline */}
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-6 leading-tight">
                    Ative o modo{" "}
                    <span className="bg-gradient-to-r from-blue-600 to-emerald-500 bg-clip-text text-transparent">
                        Natal Digital
                    </span>{" "}
                    na sua advocacia
                    <br />
                    com os Pacotes Especiais da <span className="text-blue-600">Facilita</span>!
                </h2>

                {/* Subheadline */}
                <p className="text-gray-600 text-lg max-w-4xl mx-auto mb-6">
                    Fechar o ano com o escritório sem prazos, organizado e com todas as demandas em dia é totalmente possível. A
                    Facilita assume o operacional, e você aproveita um recesso leve para começar 2026 forte, lucrativo e com a
                    mente limpa para construir o ano mais poderoso da sua advocacia.
                </p>

                {/* Gift callout */}
                <div className="inline-flex items-center bg-amber-50 border border-amber-200 text-amber-800 px-4 py-2 rounded-full text-sm font-medium">
                    <Gift className="w-4 h-4 mr-2" />
                    Na compra de qualquer pacote, você resgata um <span class="text-blue-800 font-bold mx-1">super presente da Facilita Jurídico</span> para impulsionar seu
                    escritório já no início de 2026
                </div>
            </div>
        </div>
    ),
    footer: () => (
        <div className="w-full mt-12 text-center">
            <div className="inline-flex items-center gap-4 bg-gradient-to-r from-[#2563EB]/5 to-[#00A87E]/5 border border-[#2563EB]/20 rounded-2xl px-8 py-6 shadow-sm">
                <Gift className="w-10 h-10 text-[#F2C94C]" />
                <div className="text-left">
                    <p className="text-[#1E40AF] font-semibold text-lg">
                        Comece 2026 com o pé direito!</p>
                    <p className="text-[#4A4A4A] text-sm">
                        Escolha seu pacote e garanta seu presente exclusivo da Facilita Jurídico</p>
                </div>
            </div>
        </div>
    ),
}

export default eventChristmas2025Config;